module.exports = __webpack_public_path__ + "img/28_16.51883a66.png";